import React from "react";
import { Container, Typography, Button, Stack } from "@mui/material";

const Analytics = ({ setView }) => {
	  const buttons = [
		      { label: "Easy/Medium/Hard Summaries (Summarization Analytics)", view: "easymediumhard" },
		      { label: "Logs (Descriptive Analytics)", view: "logexportviewer" },
		      { label: "Session Scores (Diagnostic Analytics)", view: "sessionscoreschart" },
		      { label: "Session Feedback (Prognostic Analytics)", view: "sessionfeedback" },
		      { label: "Predictions (ToDo) (Predictive Analytics)", view: "sessionfeedback" }
		    ];

	  return (
		      <Container maxWidth="md" sx={{ mt: 4 }}>
		        <Typography variant="h4" gutterBottom>
		          Analytics
		        </Typography>
		        <Stack spacing={2}>
		          {buttons.map(({ label, view, variant }) => (
				            <Button
				              key={view}
				              variant={variant || "text"}
				              onClick={() => setView(view)}
				            >
				              {label}
				            </Button>
				          ))}
		        </Stack>
		      </Container>
		    );
};

export default Analytics;

